module.exports = __webpack_public_path__ + "screenshot.6d1a131c14a08e5e2e9202334aeb72fe.png";